import type { NavigateOptions } from "@tanstack/react-router";
import type { CommandView } from "@/app/command-palette/palette-store";
import type { CommandContext, CommandDefinition } from "./types";

export interface DispatchCommandDeps {
  navigate: (opts: NavigateOptions) => void;
  setPaletteView: (view: CommandView) => void;
  closePalette: () => void;
  ctx: CommandContext;
}

/**
 * Given a command, decide what happens. Navigating and running an effect both
 * close the palette afterward; switching the palette view does not — closing
 * is the caller's call, never the command's.
 */
export function dispatchCommand(command: CommandDefinition, deps: DispatchCommandDeps): void {
  const { action } = command;

  switch (action.type) {
    case "navigate":
      deps.navigate(action.to);
      deps.closePalette();
      return;
    case "palette-view":
      deps.setPaletteView(action.view);
      return;
    case "effect":
      action.run(deps.ctx);
      deps.closePalette();
      return;
  }
}
